"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalProductItemSchema = exports.VerticalProductTabItemSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("../display/widgets/common");
var ActionSchema = zod_1.z.object({
    app: zod_1.z.string(),
    web: zod_1.z.string(),
});
exports.VerticalProductTabItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    distance: zod_1.z.string().optional(),
    titleClassName: zod_1.z.string().optional(),
    rootClassName: zod_1.z.string().optional(),
    discountRate: zod_1.z.string().optional(),
    price: zod_1.z.object({
        text: zod_1.z.string(),
        isValid: zod_1.z.boolean(),
    }),
    priceUnit: zod_1.z.string().nullable(),
    imageUrl: zod_1.z.string(),
    score: zod_1.z.string().optional(),
    reviewCount: zod_1.z.string().optional(),
    hasGoldClassBadge: zod_1.z.boolean().optional(),
    description: zod_1.z.string().optional(),
    /**
     * 판매예정 배지
     * sHome 공연/전시에서만 사용하는 배지로, 상품의 판매상태가 판매예정일 경우에만 노출됩니다.
     * 또한 '판매예정'1개만 추가되고 여러개 나열되지 않습니다.
     */
    badgeText: zod_1.z.string().optional(),
    rank: zod_1.z.string().optional(),
    mobileRatio: zod_1.z.enum(['1_1', '3_4']).optional(),
    image: zod_1.z
        .object({
        height: zod_1.z.number(),
        width: zod_1.z.number(),
        url: zod_1.z.string().optional(),
        unit: zod_1.z.enum(['FLEXIBLE', 'FIXED']),
    })
        .nullish()
        .optional(),
    action: ActionSchema,
    logMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    generalTypeWidth: zod_1.z.number().optional(),
    features: zod_1.z.array(common_1.CommonResponseItemPropertyDto).nullish(),
});
exports.VerticalProductItemSchema = exports.VerticalProductTabItemSchema.omit({
    badgeText: true,
    rank: true,
    mobileRatio: true,
    title: true,
}).extend({
    title: zod_1.z.union([
        zod_1.z.string(),
        zod_1.z.object({
            tripType: zod_1.z.enum(['round-trip', 'one-way']),
            departureCity: zod_1.z.string(),
            arrivalCity: zod_1.z.string(),
        }),
    ]),
    distance: zod_1.z.string().optional(),
    flightDate: zod_1.z.string().optional(),
    bottomBadgeText: zod_1.z.string().optional(),
    titleClassName: zod_1.z.string().optional(),
    rootClassName: zod_1.z.string().optional(),
});
